/* eslint-disable */

import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import Socket from '@/socket'
import Config from '@/config'
import VueAxios from 'vue-axios'
import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
import VueTheMask from 'vue-the-mask'
import VueLazyload from 'vue-lazyload'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/../public/styles/fontawesome.css'
import '@/../public/styles/main.css'

const Chat = require('@/common/chat.js')
Vue.use(VueAxios, axios)
Vue.use(BootstrapVue)
Vue.use(Config)
Vue.use(VueTheMask)
Vue.use(VueLazyload)

axios.defaults.withCredentials = true
Vue.config.productionTip = false


store.dispatch('fetchUserData').then(async (resp) => {
  Vue.use(Socket, store)

  if (resp.userData) {
    Chat({
      login: resp.userData.login + ', ' + resp.userData.id + ', ' + 'VipMagnit',
      email: resp.userData.email
    })
  } else {
    Chat()
  }

  store.dispatch('fetchApiData')
  store.dispatch('fetchFlashMessages')
  new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {App},
    render: h => h(App),
    async mounted() {
      this.mountExternalSources()
    },
    methods: {
      mountExternalSources() {
        [
          {type: 'css', src: `${this.$_config.baseUrl}/static/public/js/claim/main.css`},
          {type: 'js', src: `${this.$_config.baseUrl}/static/public/js/claim/claim.js`}
        ].forEach((source) => {
          let elem = null
          if (source.type === 'js') {
            elem = document.createElement('script')
            elem.src = source.src
          } else if (source.type === 'css') {
            elem = document.createElement('link')
            elem.setAttribute('rel', 'stylesheet')
            elem.href = source.src
          }
          document.head.appendChild(elem)
        })
      }
    }
  })
})

